import React, { useEffect, useState } from 'react';
import './Receipt.css';
import { useStateValue } from './StateProvider';
import { getBasketTotal } from './reducer';
import ReceiptProduct from './ReceiptProduct';
import SubtotalReceipt from './SubtotalReceipt';
import { useHistory } from 'react-router-dom';

function Receipt() {
    const [{ basket, cdetails, user }, dispatch] = useStateValue();
    const [products, setProducts] = useState([]);
    const [total, setTotal] = useState('');
    const [items, setItems] = useState('');
    const history = useHistory();

    useEffect(() => {
    
        if(user.length === 0){
            history.push('/');
        }    
    }, [])

    useEffect(() => {
        basket.map(item => {
            setProducts((prevFriends) => [
                ...prevFriends,
                {
                    id: item.id,
                    title: item.title,
                    price: item.price,
                    img: item.img,
                    qnt: item.qnt
                },
            ])
        })

        setTotal(getBasketTotal(basket))
        setItems(basket.length)

        dispatch({
            type: "EMPTY_TO_BASKET"
        });

    }, [])
    

    return (
        <div className="receipt">
            <div className='receipt__container'>
                {/* Payment section - Review Items */}
                <div className='receipt__title'>
                    <h3>Review items</h3>
                </div>
                <div className="receipt__items">
                    {products.map(item => (
                        <ReceiptProduct 
                            id = {item.id}
                            title={item.title}
                            price={item.price} 
                            img={item.img}
                            qnt={item.qnt}
                        />
                    ))}
                </div>
                <SubtotalReceipt 
                    total = {total}
                    items = {items}
                />
                {/* Payment section - delivery address */}
                <div className='receipt__section'>
                    <div className='receipt__title'>
                        <h3>Reservation Details</h3>
                    </div>
                    {cdetails.map(item => (
                        <div className='receipt__details'>
                            <div className='receipt__content'>
                                <label>Name:</label>
                                <p>{item.fname +' '+ item.lname}</p>
                            </div>
                            <div className='receipt__content'>
                                <label>Address:</label>
                                <p>{item.address}</p>
                            </div>
                            <div className='receipt__content'>
                                <label>Email:</label>
                                <p>{item.email}</p>
                            </div>
                            <div className='receipt__content'>
                                <label>Phone Number:</label>
                                <p>{item.phone}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default Receipt;
